module.exports = __webpack_public_path__ + "static/media/codeviolations.7ea016df.csv";